const versionNumber = "2.2.4";

export default versionNumber;
